module.exports = __webpack_public_path__ + "img/sowhatbuy-features-slider.cf06d9a6.jpg";